export default (theme) => ({
    treeRoot: {
        listStyle: 'none',
        background: theme.colors.transparent,
        margin: 0,
        padding: 0,
    },
    subtree: {
        listStyle: 'none',
        paddingLeft: 20,
        margin: 0,
    },
    nodeWrapper: {
        position: 'relative',
    },
    node: {
        display: 'flex',
        alignItems: 'center',
    },
    isSelectable: {
        '& $nodeItem': {
            cursor: 'pointer',
        },
        '& $nodeIcon': {
            cursor: 'pointer',
        },
    },
    isDisabled: {
        opacity: 0.5,
        cursor: 'initial !important',
        '& $nodeItem': {
            fontWeight: '400 !important',
        },
        '& $nodeIcon': {
            cursor: 'initial !important',
        },
    },
    active: {
        '& $nodeItem': {
            background: theme.colors.transparent,
            fontWeight: 500,
            color: theme.colors.primary.black,
        },
    },
    toggled: {
        '& $nodeIcon': {
            transform: 'rotate(0deg) !important',
        },
    },
    empty: {
        marginLeft: 20,
        '& $nodeIcon': {
            display: 'none',
        },
    },
    nodeItem: {
        position: 'relative',
        padding: '7.5px 0',
        lineHeight: '20px',
        ...theme.typography.defaultText,
        color: theme.colors.utility.textPrimary,
    },
    nodeIcon: {
        marginRight: 10,
        transform: 'rotate(-90deg)',
        transition: 'transform 0.2s',
        cursor: 'pointer',
    },
});
